import { useEmailVerification } from '../http-initiate-verification/useEmailVerification';
import imageUrls from '../images/imageUrls';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
const RateLimitedEmailVerification = () => {
  const {
    resendEmail
  } = useEmailVerification();
  const onClick = event => {
    event.preventDefault();
    resendEmail();
  };
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.RateLimitedEmailVerification,
    handleButtonClick: onClick,
    imageURL: imageUrls.clock
  });
};
export default RateLimitedEmailVerification;